<template>
  <div class='resubRedirect--main'>
    <b-spinner
      v-if='isLoading'
      label="Large Spinner">
    </b-spinner>
  </div>
</template>

<script>
import storage from '@/storage'
import { mapState, mapMutations, mapActions } from 'vuex'
import { errorPrompt } from '@/prompts'
export default {
  name: 'resubmission-redirect-step-two',
  data () {
    return {
      isRedirected: false,
      isLoading: true
    }
  },
  computed: {
    ...mapState({
      token: state => state['token']
    })
  },
  methods: {
    ...mapMutations({
      setErrorWithResubmissionToken: 'SET_ERROR_WITH_RESUBMISSION_TOKEN'
    }),
    ...mapActions({
      getSupplementary: 'getSupplementary',
      getResubmissionData: 'getResubmissionData'
    }),
    handleSSOLoginSuccess (resubmissionToken) {
      this.isLoading = false
      this.$router.push({ name: 'resubmission-form' })
    },
    handleSSOLoginError (error) {
      this.isRedirected = false
      this.isLoading = false
      if (error) {
        const errorOptions = {
          confirmButtonText: this.$i18n.t('swal.ok-button')
        }
        if (error.response.status === 403) {
          errorPrompt(this.$i18n.t('swal.login.resubmissionAlreadyDone'), errorOptions)
          this.$router.push({ name: 'home' })
        } else if (error.response.status === 419) {
          errorPrompt(this.$i18n.t('swal.resubmission-form.reject-error-403-dublicate'), errorOptions)
          this.$router.push({ name: 'home' })
        } else if (error.response.status === 406) {
          errorPrompt(this.$i18n.t('swal.resubmission-form.reject-error-406-periodIsOver'), errorOptions)
          this.$router.push({ name: 'home' })
        } else if (error.response.status === 412) {
          errorPrompt(this.$i18n.t('swal.resubmission-form.reject-error-412-studentInactive'), errorOptions)
          this.$router.push({ name: 'home' })
        } else if (error.response.status === 405) {
          errorPrompt(this.$i18n.t('swal.resubmission-form.reject-error-405-noApplicationFoundForThisUser'), errorOptions)
          this.$router.push({ name: 'home' })
        } else if (error.response.status === 423) {
          errorPrompt(this.$i18n.t('swal.resubmission-form.reject-error-423-childDoesNotBelongToUser'), errorOptions)
          this.$router.push({ name: 'home' })
        } else {
          this.setErrorWithResubmissionToken(true)
          return this.$router.push({ name: 'home' })
        }
      }
    }
  },
  created () {
    let schools = localStorage.getItem('schools')
    let payload = { 'token': this.token, 'schools': schools, 'resubToken': storage.get.resubmissionToken() }
    this.getSupplementary(payload)
      .then(() => {
        this.getResubmissionData(payload)
          .then(res => {
            this.handleSSOLoginSuccess(payload)
          })
          .catch(err => {
            this.handleSSOLoginError(err)
          })
      })
      .catch(err => {
        this.handleSSOLoginError(err)
      })
    // }
  }
}
</script>

<style lang='scss' scoped>
.resubRedirect--main {
  position: relative;
}
.spinner-border {
  position: absolute;
  top: 70%;
  left: 45%;
  width: 5rem;
  height: 5rem;
  border: 0.4em solid white;
  border-right-color: transparent;
}
.mt-app--box {
  min-height: 30vh;
  background-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
